module.exports = __webpack_public_path__ + "static/media/evilwizard.f4c15ed3.png";